import React from 'react';
import PropTypes from 'prop-types';
import styles from './PdpSharedDealerDistinctions.scss';
import classnames from 'classnames';
import { SharedTooltip } from '../../shared/SharedTooltip';

export const PdpSharedDealerDistinction = ({
    title,
    description,
    icon: Icon,
    dataTn,
    customIconStyles,
}) => {
    const iconClassName = classnames(customIconStyles, styles.icon);
    if (!description) {
        return (
            <div className={styles.tooltipTrigger}>
                <Icon className={iconClassName} />
                <span className={styles.title}>{title}</span>
            </div>
        );
    }
    return (
        <SharedTooltip
            dataTn={dataTn}
            linkClass={styles.tooltipTrigger}
            align="right"
            direction="bottom"
            paddingSize="small"
            tooltipContent={description}
        >
            <Icon className={iconClassName} />
            <span className={styles.title}>{title}</span>
        </SharedTooltip>
    );
};

PdpSharedDealerDistinction.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
    customIconStyles: PropTypes.string,
};
